import { Image, Text, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';

import { styles } from './styles';

type LogoProps = {
  source: string;
  extraStyles?: Style[];
  text?: string;
};

export function Logo({ source, extraStyles, text }: LogoProps) {
  return (
    <View style={[styles.section, styles.alignCenter]}>
      <Image src={source} style={[styles.logo, ...(extraStyles || [])]} />
      {text ? <Text style={styles.textSmall}>{text}</Text> : null}
    </View>
  );
}
